import { PrototypeApiError } from '../apiClient';

export type OAuthLinkFailure = {
	message: string;
	refreshTurnstile: boolean;
};

export function describeOAuthLinkFailure(error: unknown): OAuthLinkFailure {
	if (!(error instanceof PrototypeApiError)) {
		return { message: 'Google could not be linked. Please start Google sign-in again.', refreshTurnstile: false };
	}
	const code = (error.body as { error?: string } | null)?.error;
	if (error.status === 401 && code === 'current_password_invalid') {
		return { message: 'That password is incorrect.', refreshTurnstile: true };
	}
	if (error.status === 403 && (code === 'turnstile_required' || code === 'turnstile_failed')) {
		return { message: 'Security verification expired. Please complete it again.', refreshTurnstile: true };
	}
	if (error.status === 429) {
		return { message: 'Too many attempts. Please wait a minute, then try again.', refreshTurnstile: false };
	}
	if (error.status === 400 && code === 'oauth_link_expired') {
		return { message: 'This Google sign-in request expired. Please start again.', refreshTurnstile: false };
	}
	if (error.status === 409 && code === 'oauth_link_conflict') {
		return { message: 'This Google account could not be linked safely. Please start again.', refreshTurnstile: false };
	}
	return { message: 'Google could not be linked. Please start Google sign-in again.', refreshTurnstile: false };
}
